import { render, staticRenderFns } from "./IndexMain.vue?vue&type=template&id=498ecd9a&scoped=true"
import script from "./IndexMain.vue?vue&type=script&lang=js"
export * from "./IndexMain.vue?vue&type=script&lang=js"
import style0 from "./IndexMain.vue?vue&type=style&index=0&id=498ecd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules_admin/6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ecd9a",
  null
  
)

export default component.exports